"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPACE_FIELD_META = exports.spaceCreateSchema = exports.mongoIdSchema = exports.SPACE_NAME_MAX = exports.SPACE_GENDERS = exports.SPACE_GENDER_VALUES = exports.SPACE_TYPES = exports.SPACE_TYPE_VALUES = void 0;
/**
 * Contract della risorsa Space — definizione unica da cui derivano:
 * DTO backend, tipi frontend, config form (CustomFormV3) e vincoli e2e.
 *
 * Derivato dalla realtà del codice (2026-07-26):
 * - apps/backend/src/spaces/dto/create-space.dto.ts  → campi name/type/gender (+directorId server-side)
 * - apps/backend/src/mongoSchemas/Space.ts           → tutti required; NESSUN max su `name` nel DB
 * - apps/backend/src/enums/space.ts                  → valori esatti SPACE_TYPES / SPACE_GENDERS
 * - apps/frontend/src/components/TeamsAndSpaces/AddSpaceModal.tsx → form = name+type+gender, label IT
 *
 * Separazione dei ruoli:
 * - `spaceCreateSchema`  = REGOLE dato (validazione)
 * - `SPACE_FIELD_META`   = PRESENTAZIONE (label IT, ordine campi) — mai dentro lo schema
 *
 * NB: il DTO backend richiede anche `directorId` (IsMongoId), ma è identità
 * server-side aggiunta dal client API, non un campo del form: per questo è
 * fuori da `spaceCreateSchema` ed esposto a parte come `mongoIdSchema`.
 */
const zod_1 = require("zod");
/**
 * Valori ESATTI dell'enum backend SPACE_TYPES (apps/backend/src/enums/space.ts).
 * NB: nel backend la chiave volley è `VOLLER_BALL` (refuso storico) — il VALORE
 * canonico è `volley-ball`; qui la chiave è corretta in VOLLEY_BALL.
 */
exports.SPACE_TYPE_VALUES = [
    'basket',
    'athletics',
    'soccer',
    'rugby-union',
    'volley-ball',
    'gym',
];
exports.SPACE_TYPES = {
    BASKET: 'basket',
    ATHLETICS: 'athletics',
    SOCCER: 'soccer',
    RUGBY_UNION: 'rugby-union',
    VOLLEY_BALL: 'volley-ball',
    GYM: 'gym',
};
/** Valori ESATTI dell'enum backend SPACE_GENDERS. */
exports.SPACE_GENDER_VALUES = ['male', 'female', 'mixed'];
exports.SPACE_GENDERS = {
    MALE: 'male',
    FEMALE: 'female',
    MIXED: 'mixed',
};
/**
 * Il Mongo schema non impone un max su `name`: 100 è il tetto pragmatico
 * scelto per la UI (nessun dato esistente si avvicina; evita abusi input).
 */
exports.SPACE_NAME_MAX = 100;
/** ObjectId Mongo (equivalente di @IsMongoId per gli id passati dal client API). */
exports.mongoIdSchema = zod_1.z
    .string()
    .regex(/^[0-9a-fA-F]{24}$/, 'Id non valido');
/** Schema di creazione Space = i campi del form (il BE aggiunge directorId). */
exports.spaceCreateSchema = zod_1.z.object({
    name: zod_1.z
        .string({ required_error: 'Il nome è obbligatorio' })
        .trim()
        .min(1, 'Il nome è obbligatorio')
        .max(exports.SPACE_NAME_MAX, `Massimo ${exports.SPACE_NAME_MAX} caratteri`),
    type: zod_1.z.enum(exports.SPACE_TYPE_VALUES, {
        errorMap: () => ({ message: 'Tipologia non valida' }),
    }),
    gender: zod_1.z.enum(exports.SPACE_GENDER_VALUES, {
        errorMap: () => ({ message: 'Sesso non valido' }),
    }),
});
/**
 * Meta di PRESENTAZIONE (label IT, ordine, label opzioni) — separato dallo
 * schema. Le label combaciano con le option FE attuali
 * (TYPE_TEAM_OPTIONS / GENDER_TEAM_OPTIONS in constants/config).
 */
exports.SPACE_FIELD_META = {
    order: ['name', 'type', 'gender'],
    fields: {
        name: {
            label: 'Nome spazio',
            required: true,
        },
        type: {
            label: 'Tipologia',
            required: true,
            optionLabels: {
                soccer: 'Calcio',
                athletics: 'Atletica',
                basket: 'Basket',
                'rugby-union': 'Rugby a 15',
                'volley-ball': 'Pallavolo',
                gym: 'Palestra',
            },
        },
        gender: {
            label: 'Sesso',
            required: true,
            optionLabels: {
                male: 'Maschile',
                female: 'Femminile',
                mixed: 'Misto',
            },
        },
    },
};
